<p class="mb-2 text-muted small">
    Adjunta los archivos solicitados en formato PDF o imagen asegurándote de que sean legibles.
</p>
<div class="form-bloque-documents">
    <div class="text-uppercase text-secondary mb-2 fw-semibold small">Documentos requeridos</div>
    <div class="d-flex flex-column gap-3">
        <div class="card border-0 shadow-sm">
            <div class="card-body p-3">
                <div class="fw-semibold mb-2">Identificación oficial</div>
                @if (getFileName('idDocument')) {
                <div class="text-success small mb-2 d-flex justify-content-between align-items-center">
                    <span class="d-flex align-items-center gap-1">
                        <span>📎</span> Archivo seleccionado: <strong class="ms-1">{{ getFileName('idDocument')
                            }}</strong>
                    </span>
                    <button (click)="removeFile('idDocument')"
                        class="btn btn-sm btn-outline-danger rounded-pill py-0 px-2" type="button">Quitar</button>
                </div>
                }
                <div class="input-group">
                    <input type="file" class="form-control" id="uploadIdDocument"
                        accept=".pdf,.jpg,.jpeg,.png,.webp,.heic" (change)="onFileChange('idDocument', $event)">
                    <label class="input-group-text" for="uploadIdDocument">Subir</label>
                </div>
                <div class="text-muted small mt-1" style="font-size: 0.75rem;">Límite de tamaño: 40MB. Formatos
                    permitidos: .jpg, .png, .webp,
                    .heic, .pdf</div>
                @if (fileErrors['idDocument']) {
                <div class="text-danger small mt-1">{{ fileErrors['idDocument'] }}</div>
                }
            </div>
        </div>
        <div class="card border-0 shadow-sm">
            <div class="card-body p-3">
                <div class="fw-semibold mb-2">Carta laboral</div>
                @if (getFileName('workLetter')) {
                <div class="text-success small mb-2 d-flex justify-content-between align-items-center">
                    <span class="d-flex align-items-center gap-1">
                        <span>📎</span> Archivo seleccionado: <strong class="ms-1">{{ getFileName('workLetter')
                            }}</strong>
                    </span>
                    <button (click)="removeFile('workLetter')"
                        class="btn btn-sm btn-outline-danger rounded-pill py-0 px-2" type="button">Quitar</button>
                </div>
                }
                <div class="input-group">
                    <input type="file" class="form-control" id="uploadWorkLetter"
                        accept=".pdf,.jpg,.jpeg,.png,.webp,.heic" (change)="onFileChange('workLetter', $event)">
                    <label class="input-group-text" for="uploadWorkLetter">Subir</label>
                </div>
                <div class="text-muted small mt-1" style="font-size: 0.75rem;">Límite de tamaño: 40MB. Formatos
                    permitidos: .jpg, .png, .webp,
                    .heic, .pdf</div>
                @if (fileErrors['workLetter']) {
                <div class="text-danger small mt-1">{{ fileErrors['workLetter'] }}</div>
                }
            </div>
        </div>
        <div class="card border-0 shadow-sm">
            <div class="card-body p-3">
                <div class="fw-semibold mb-2">Exámenes médicos</div>
                @if (getFileName('medicalTests')) {
                <div class="text-success small mb-2 d-flex justify-content-between align-items-center">
                    <span class="d-flex align-items-center gap-1">
                        <span>📎</span> Archivo seleccionado: <strong class="ms-1">{{ getFileName('medicalTests')
                            }}</strong>
                    </span>
                    <button (click)="removeFile('medicalTests')"
                        class="btn btn-sm btn-outline-danger rounded-pill py-0 px-2" type="button">Quitar</button>
                </div>
                }
                <div class="input-group">
                    <input type="file" class="form-control" id="uploadMedicalTests"
                        accept=".pdf,.jpg,.jpeg,.png,.webp,.heic" (change)="onFileChange('medicalTests', $event)">
                    <label class="input-group-text" for="uploadMedicalTests">Subir</label>
                </div>
                <div class="text-muted small mt-1" style="font-size: 0.75rem;">Límite de tamaño: 40MB. Formatos
                    permitidos: .jpg, .png, .webp,
                    .heic, .pdf</div>
                @if (fileErrors['medicalTests']) {
                <div class="text-danger small mt-1">{{ fileErrors['medicalTests'] }}</div>
                }
            </div>
        </div>
        <div class="card border-0 shadow-sm">
            <div class="card-body p-3">
                <div class="fw-semibold mb-2">Otros documentos</div>
                @if (getFileName('additionalDocs')) {
                <div class="text-success small mb-2 d-flex justify-content-between align-items-center">
                    <span class="d-flex align-items-center gap-1">
                        <span>📎</span> Archivo seleccionado: <strong class="ms-1">{{ getFileName('additionalDocs')
                            }}</strong>
                    </span>
                    <button (click)="removeFile('additionalDocs')"
                        class="btn btn-sm btn-outline-danger rounded-pill py-0 px-2" type="button">Quitar</button>
                </div>
                }
                <div class="input-group">
                    <input type="file" class="form-control" id="uploadAdditionalDocs" multiple
                        accept=".pdf,.jpg,.jpeg,.png,.webp,.heic" (change)="onFileChange('additionalDocs', $event)">
                    <label class="input-group-text" for="uploadAdditionalDocs">Subir</label>
                </div>
                <div class="text-muted small mt-1" style="font-size: 0.75rem;">Límite de tamaño: 40MB. Formatos
                    permitidos: .jpg, .png, .webp,
                    .heic, .pdf</div>
                @if (fileErrors['additionalDocs']) {
                <div class="text-danger small mt-1">{{ fileErrors['additionalDocs'] }}</div>
                }
            </div>
        </div>
    </div>
</div>